import React, { FunctionComponent } from 'react';
import {
  Chip,
  TextField,
  Grid,
} from '@material-ui/core';
import ChipInput from 'material-ui-chip-input';
import { makeStyles } from '@material-ui/core/styles';

import Spec from '../../models/Spec';
import { TestCaseInputChange } from '../../types/HTMLPropsTypes';

interface Props {
  data: Spec['data'][0];
  index: number;
  onChange?: (data: Spec['data'][0]) => void;
  handleRemoveInputVal: (testCaseIndex: number, inputIndex: number) => void;
  handleTestCaseChange: TestCaseInputChange;
}

const useStyles = makeStyles((theme) => ({
  chip: {
    maxWidth: '40vw !important',
  },
}));

const TestCaseForm: FunctionComponent<Props> = ({
  data,
  handleRemoveInputVal,
  index,
  handleTestCaseChange,
  onChange
}: Props) => {
  const classes = useStyles();
  // To be implemented later
  // const [enableAutofill, setEnableAutofill] = useState<boolean>(true);

  // const handleAutofillChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setEnableAutofill(event.target.checked);
  // };

  const handleOnChipsChange = (chips: string[]) => {
    if (onChange) {
      const newData = {...data};
      newData.arguments = chips;
      onChange(newData);
    }
  };

  const handleCopyToClipboard = (value: string) => {
    navigator.clipboard.writeText(value);
  };
  return (
    <form className="w-100">
      <Grid container>
        <Grid item md={6} className=" pr-4 py-2">
          <Grid container className="mb-3">
            <ChipInput
              allowDuplicates={true}
              value={data.arguments}
              label="Inputs"
              fullWidth
              chipRenderer={({ value, handleDelete, className }, key) => (
                <Chip
                  key={key}
                  className={`${className} ${classes.chip}`}
                  label={value}
                  onDelete={handleDelete}
                  onClick={() => handleCopyToClipboard(value)}
                />
              )}
              onChange={handleOnChipsChange}
              onAdd={(chip) => handleTestCaseChange(index, 'arguments', chip)}
              onDelete={(chip, i) => handleRemoveInputVal(index, i)}
            />
          </Grid>

          <Grid container className="mb-3">
            {/* <Grid item xs={9}> */}
            <TextField
              label="Invoker"
              multiline
              fullWidth
              rows={3}
              rowsMax={5}
              value={data.mainInvoker}
              onChange={(e) =>
                handleTestCaseChange(index, 'mainInvoker', e.target.value)
              }
            />
            {/* </Grid>
          <Grid item xs={3} className="d-flex justify-content-end">
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={enableAutofill}
                  onChange={handleAutofillChange}
                />
              }
              label="Autofill"
            />
          </Grid> */}
          </Grid>
        </Grid>
        <Grid item container alignItems="flex-end" md={6} className="pl-4 py-2">
          <Grid container className="mb-3">
            <TextField
              label="Output"
              multiline
              onChange={(e) =>
                handleTestCaseChange(index, 'output', e.target.value)
              }
              fullWidth
              rows={3}
              rowsMax={5}
              value={data.output}
            />
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default TestCaseForm;
